<template>
  <div>
    <div v-show="isMain">
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">产品定义</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="110px" size="small">
        <el-row>
          <el-col :span="5">
            <el-form-item label="产品编号">
              <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="产品规格">
              <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="产品属性">
              <el-select
                v-model="form.source"
                clearable
                filterable
                placeholder="请选择"
                style="width:100%;"
              >
                <el-option
                  v-for="item in orderStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="4" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="getdata">查询</el-button>
          </el-col>
        </el-row>

        <FormItem :setList="setList" :form="form" :colSpan="5" v-show="!isFold" :mode="'create'"></FormItem>
        <el-divider>
          <i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i>
        </el-divider>
      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="createProduct">创建产品</el-button>
            <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
            <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>


            <el-upload  ref="workReportImp" name="workReportImp" :action="action()" :on-change="
                (file, fileList) => {
                handleChange(file, fileList);
                }
            "
              :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

            </el-upload>
            <!-- <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
            <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button>
            <el-button type="text" icon="el-icon-s-data" @click="viewImportLog">查看导入日志</el-button>
            <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button>
            <el-button type="text" icon="el-icon-tickets">自定义事件</el-button> -->
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          @selection-change="handleTblSelectionChange"
          row-key="_id"
        >
          <el-table-column align="left" type="selection" width="60" :reserve-selection="true"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column label="产品编号" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格" width="100"></el-table-column>
          <el-table-column prop="technologyCode" label="工艺路线" width="100"></el-table-column>
          <el-table-column prop="unit" label="单位" width="90"></el-table-column>
          <el-table-column prop="maxStock" label="最大库存" width="100"></el-table-column>
          <el-table-column prop="minStock" label="最小库存" width="100"></el-table-column>
          <el-table-column prop="safeStock" label="安全库存" width="100"></el-table-column>
          <!-- :formatter="productFormat" -->
          <el-table-column prop="source" label="产品属性" width="100"></el-table-column>
          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

          <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
          <el-table-column prop="creater" label="创建人" width="140">

          </el-table-column>
           <el-table-column prop="updater" label="更新人" width="140">

          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>
          <el-table-column align="left" label="操作" min-width="190" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="打印">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip> -->

              <el-tooltip content="删除">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="handleDelete(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>
      <ImportLog v-show="!isMain" :menuName="menuName" @goBack="goBack"></ImportLog>
      <CreateProduct :diaVisible="createProductPanVisible" @save="productSave" :userData="userData" :mode="mode" :editRow="editRow" :setList="setList"></CreateProduct>
  </div>
</template>
<script>

import { productGetList ,productDelete,productBatchDelete} from '@/api/basicData';
import {queryAllCustomSet,productBatchImp} from '@/api/business';
import Pagination from "@/components/Pagination";
import ImportLog from "@/components/importLog";
import CreateProduct from '@/views/basicData/productDefinition/createProduct';
import FormItem from "@/components/FormItem";
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "ProductDefinition",
  components:{
      Pagination,
      CreateProduct,
      ImportLog,
      FormItem
  },
  data() {
    return {
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "自制"
        },
        {
          label: "外购",
          value: "外购"
        },
        {
          label: "委外",
          value: "委外"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,
      menuName:{
        first:'基础数据',
        second:'产品定义',
        three:'导入日志',
      },
      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'自制'
      },{
        label:'外购',
        value:'外购'
      },{
        label:'委外',
        value:'委外'
      }],
      setList:[],
      tblSelectionList:[]

    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();

    }
  },
  methods: {
      //导出数据前对数据处理，变为想要的格式。
      filterTableData(data) {
      data.forEach((item) => {
       item.nongoodRate = item.nongoodRate?item.nongoodRate.toFixed(2):""
      });
      return data;
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();

        return;
      }
      const header = [
        '产品编号',
        '产品名称',
        '产品规格',
        '工艺路线',

        '单位',
        '最大库存',
        '最小库存',
        '安全库存',
        '产品属性',
        '创建人',
        '创建时间',
        '更新人',
        '更新时间',

      ];

      const filterVal = [
        'productCode',
        'productName',
        'specs',
        'technologyCode',
        'unit',
        'maxStock',
        'minStock',
        'safeStock',
        'source',
        'creater',
        'createTime',
        'updater',
        'updateTime',
      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =JSON.parse(JSON.stringify(this.tblSelectionList));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"产品定义清册"+ Date.now());
    },
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          productCode:this.form.productCode,
          productName:this.form.productName,
          specs:this.form.specs,
          source:this.form.source,
          minStock:this.form.minStock,
          maxStock:this.form.maxStock,
        },
        tableName:'产品',
        collection:'product',
      }

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "产品清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        productBatchImp(data).then(res=>{
          this.search();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/product/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/product/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "产品导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["workReportImp"].$refs['upload-inner'].handleClick();
    },
    init(){
       queryAllCustomSet(this.userData.factoryId,'product').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
          this.search();
        }
      })
    },
    fold() {
      this.isFold = !this.isFold;
    },
    getdata(){
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 10;
      this.search();
    },
    search() {
      this.loading = true
      var data = {
        condition: {
          factoryId: this.userData.factoryId,
          productCode:this.form.productCode,
          productName:this.form.productName,
          specs:this.form.specs,
          source:this.form.source,
          minStock:this.form.minStock,
          maxStock:this.form.maxStock,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      productGetList(data).then(res => {
        if(res.code == 200){
          this.listData = res.data.list
          this.pageparm.total = res.data.total;
          this.loading = false
        }else{
          this.pageparm.total = 0;
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
    handleDelete(index,row){
      this.$confirm('确认删除产品？操作将同时删除关联的物料清单，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        productDelete(row._id).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function(){})
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        let self = this;
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          productBatchDelete(idList).then(res => {
              self.search();
              if (res.code == 200) {
                self.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                self.$message({
                  type: 'error',
                  message: res.msg
                })
              }

            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    handleEdit(index,row){
      this.mode = 'edit'
      this.editRow = row
      this.createProductPanVisible = true
    },
     // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.search();
    },
    createProduct(){
      this.mode = 'create'
      this.editRow = {}
      this.createProductPanVisible = true;
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/basicData/productDefinition/ProductDefinition.vue